import api from './api';

export interface MonitoringService {
  id: number;
  name: string;
  url: string;
  api_key_masked: string;
  sort_order: number;
}

export interface MonitoringServiceCreate {
  name: string;
  url: string;
  api_key: string;
  sort_order?: number;
}

export interface MonitoringServiceUpdate {
  name?: string;
  url?: string;
  api_key?: string;
  sort_order?: number;
}

export interface TestConnectionResponse {
  ok: boolean;
  message: string;
  environments?: string[];
}

export const monitoringServicesService = {
  list: async (): Promise<MonitoringService[]> => {
    const res = await api.get<MonitoringService[]>('/monitoring-services/');
    return res.data;
  },
  create: async (data: MonitoringServiceCreate): Promise<MonitoringService> => {
    const res = await api.post<MonitoringService>('/monitoring-services/', data);
    return res.data;
  },
  update: async (id: number, data: MonitoringServiceUpdate): Promise<MonitoringService> => {
    const res = await api.put<MonitoringService>(`/monitoring-services/${id}`, data);
    return res.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/monitoring-services/${id}`);
  },
  testConnection: async (url: string, apiKey: string): Promise<TestConnectionResponse> => {
    const res = await api.post<TestConnectionResponse>('/monitoring-services/test', {
      url: url.trim().replace(/\/+$/, ''),
      api_key: apiKey,
    });
    return res.data;
  },
  testExistingService: async (id: number): Promise<TestConnectionResponse> => {
    const res = await api.post<TestConnectionResponse>(`/monitoring-services/${id}/test`);
    return res.data;
  },
};
